/****************************************************************
Alexander Self
8/23/17
Gang list:Displyas a list of gangs
****************************************************************/
import React from 'react';
import moment from 'moment';

const HarvestList = ({ harvest, onClick, id }) => {
  if (!harvest) return <div>No Harvest Available for Edit</div>;
  return (
    <ul className="collection" id={id}>
      {
        harvest.map((h) => {
          return (
            <li key={h.id} className="collection-item harvest-list-item waves-light" onClick={() => onClick(h)}>
              <div className="row">
                <div className="col s6 m6 l6 xl6">
                  <b>{ moment(h.date).format('YYYY-MM-DD') }</b> <hr />
                  <b>Rd. { h.round }</b>
                </div>
                <div className="col s6 m6 l6 xl6">
                  <b>{ h.field }</b> <hr />
                  <b>{ h.estimatedLbs } lbs</b>
                </div>
              </div>
            </li>
          )
        })
      }
    </ul>
  );
};

export default HarvestList;



// WEBPACK FOOTER //
// ./src/components/harvest/harvest_list.jsx